import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/dashboard-counts`;
const API_URL_2 = `${process.env.REACT_APP_API_URL}/api/admin/admin-dashboard-counts`;

// const headers = {
//   "Content-Type": "multipart/form-data",
//   "Accept": "application/json"
// };

export const fetchDashboardCounts = (payload) => apiHelper(API_URL, 'GET', payload);
export const fetchAdminDashboardCounts = () => apiHelper(API_URL_2, 'GET');

